export const pxToRem = (px: number) => `${px / 16}rem`;
